import styled from 'styled-components';
import rtl from 'styled-components-rtl';
import { toRem, theme } from '@marriott/mi-ui-library-shop';

export const Styled = styled.div`
  ${rtl`
  .information-component{
    scroll-margin-top: ${toRem(136)};
    margin: auto;
    max-width: ${toRem(1440)};
    background-color: ${theme.color['white']};
    padding: ${toRem(10)} ${toRem(158)} ${toRem(16)};
    font-family: ${theme.fonts['fontFamilySwiss']};
    .component-heading{
      margin-bottom: ${toRem(24)};
    }
    .component-content{
      display: flex;
      flex: 0;
      flex-direction: row;
      justify-content: space-between;
      width: 100%;
      padding-bottom: ${toRem(17)};
      border-bottom: ${toRem(1)} solid ${theme.color['alto']};
    }
    .component-content>*{
      flex-basis: 100%;
      flex-grow: 0;
    }
    .component-content-small-screen{
      display: none;
      border-bottom: ${toRem(1)} solid ${theme.color['alto']};
    }
  }
  .space-buffer{
    scroll-margin-top: ${toRem(255)};
  }
  @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
    .information-component{
      margin-top: ${toRem(-150)};
      padding-top: ${toRem(150)};
    }
    .space-buffer{
      margin-top: ${toRem(-275)};
      padding-top: ${toRem(275)};
    }
  }

  @media only ${theme.mediaQuery.allTablets} {
    .information-component{
      padding-left: ${toRem(32)};
      padding-right: ${toRem(32)};
    }
  }
  @media only ${theme.mediaQuery.smallerTablet} {
    .information-component{
      scroll-margin-top: ${toRem(30)};
      padding-left: ${toRem(32)};
      padding-right: ${toRem(32)};
      padding-top: ${toRem(33)};
      .component-heading{
        margin-bottom: ${toRem(24)};
      }
      .component-content{
        display: none;
      }
      .component-content-small-screen{
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        width: 100%;
        .right-content{
          display: flex;
          flex-direction: column;
        }
      }
    }
    .space-buffer{
      scroll-margin-top: ${toRem(80)};
    }
  }
  @media only ${theme.mediaQuery.allMobiles} {
    .information-component{
      padding: ${toRem(20)} ${toRem(16)} ${toRem(20)};
      scroll-margin-top: ${toRem(30)};
      .component-heading{
        margin-bottom: ${toRem(11)};
      }
      .component-content{
        display: flex;
        flex-direction: column;
      }
      .component-content-small-screen{
        display: none;
      }
    }
  }
  .hqv-modal {
    &.information-component{
      scroll-margin-top: ${toRem(30)};
      padding-left: ${toRem(24)};
      padding-right: ${toRem(24)};
      padding-top: ${toRem(33)};
      @media only ${theme.mediaQuery.allMobiles} {
        padding: 0;
        padding-top: ${toRem(16)};
        margin-left: ${toRem(16)};
        margin-right: ${toRem(16)};
      }
      .component-heading{
        margin-bottom: ${toRem(24)};
      }
      .component-content{
        display: none;
      }
      .component-content-small-screen{
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        @media only ${theme.mediaQuery.allMobiles} {
          flex-direction:column;
        }
        width: 100%;
        .right-content{
          flex: 1;
          display: flex;
          flex-direction: column;
        }
        .left-content{
          flex: 1;
        }
      }
    }
    &.space-buffer{
      scroll-margin-top: ${toRem(80)};
    }
  }
`}
`;
